var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable } from 'rxjs/Observable';
import { CurrentOrderService } from './../currentOrder.service';
import { FlagService } from './../../modules/features/flag.service';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from '../order.service';
import { OrderValidation } from '../orderValidation';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from '../../mixpanel/mixpanel.service';
import { LocalStorageService } from '../../localstorage.service';
var $ = require('jquery');
global.jQuery = $;
require('metismenu');
var OrderSummaryComponent = (function () {
    function OrderSummaryComponent(orderService, currentOrderService, orderValidation, router, translate, flag, route, mixpanelService, localStorage) {
        this.orderService = orderService;
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
        this.router = router;
        this.translate = translate;
        this.flag = flag;
        this.route = route;
        this.mixpanelService = mixpanelService;
        this.localStorage = localStorage;
        this.canSend = true;
    }
    OrderSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: true,
            billing: true,
            shipping: true,
            summary: true,
            completed: false
        });
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.currentOrderService.order.subscribe(function (order) { return _this.order = order; });
        this.mixpanelService.trackEvent("summary page", this.orderType.lowercaseType);
        this.isAlgoliaSearchActive = this.flag.isAlgoleaSearchActive();
        this.isFileItemActive = this.flag.isFileItemActive();
        this.isFilePOActive = this.flag.isFilePOActive();
        this.isItemBrandActive = this.flag.isItemBrandActive();
    };
    OrderSummaryComponent.prototype.removeItem = function (item) {
        var index = this.order.Items.indexOf(item, 0);
        if (index > -1)
            this.order.Items.splice(index, 1);
    };
    OrderSummaryComponent.prototype.submit = function () {
        var _this = this;
        this.canSend = false;
        if (this.order.ShippingMethod == 'FEDEX') {
            this.order.CourierName = 'FEDEX';
            this.order.CourierAccountNumber = "";
        }
        // if($("#mixpanel-distinct_id").val().indexOf("@") == -1){
        //this.orderService.addMixpanelProfile(this.order, $("#mixpanel-token").val(), $("#mixpanel-distinct_id").val());
        // }
        this.localStorage.setItem('order.contact', JSON.stringify(this.order.Contact));
        this.localStorage.setItem('order.shippingAddress', JSON.stringify(this.order.ShippingAddress));
        if (this.orderType.lowercaseType == 'order') {
            this.localStorage.setItem('order.ispartialdelivery', JSON.stringify(this.order.IsPartialDelivery));
            this.localStorage.setItem('order.shippingmethod', this.order.ShippingMethod);
            this.localStorage.setItem('order.couriername', this.order.CourierName);
            this.localStorage.setItem('order.courieraccountnumber', this.order.CourierAccountNumber);
            this.localStorage.setItem('order.othercouriername', this.order.OtherCourierName);
            this.localStorage.setItem('order.deliverymethod', this.order.DeliveryMethod);
            this.localStorage.setItem('order.billingAddress', JSON.stringify(this.order.BillingAddress));
            this.localStorage.setItem('order.IsBillingAddressSame', JSON.stringify(this.order.IsBillingAddressSame));
        }
        if (this.order.CourierName == 'Other')
            this.order.CourierName = this.order.OtherCourierName;
        this.order.orderType = this.orderType.lowercaseType;
        this.orderService.addOrder(this.order, this.translate.currentLang).then(function (resp) {
            if (!resp.json().data.requestCreate)
                throw new Error("data invalid");
            _this.canSend = true;
            _this.mixpanelService.api.people.increment({
                "number_of_request": 1
            });
            _this.router.navigate(['../completed'], { relativeTo: _this.route });
        }).catch(function () {
            _this.canSend = true;
            var title = _this.translate.get('Error');
            var text = _this.translate.get('An error occured while submitting your ' + _this.orderType.lowercaseLabel);
            Observable.forkJoin(title, text).subscribe(function (res) {
                swal({
                    title: res[0],
                    text: res[1],
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK'
                });
            });
        });
    };
    OrderSummaryComponent.prototype.isValid = function () {
        var result = false;
        if (this.orderType.lowercaseType == "order" && this.canSend)
            result = this.orderValidation.isOrderValid();
        else if (this.orderType.lowercaseType == "quote" && this.canSend)
            result = this.orderValidation.isQuoteValid();
        return result;
    };
    OrderSummaryComponent.prototype.resetOrder = function () {
        this.currentOrderService.resetOrder();
        this.router.navigate([this.orderType.lowercaseType]);
    };
    OrderSummaryComponent.prototype.showCancelAlert = function () {
        var _this = this;
        swal({
            title: 'Cancelling ' + this.orderType.uppercaseType,
            text: 'Are you sure you want to cancel your current ' + this.orderType.lowercaseType + '?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No, keep it'
        }).then(function () {
            _this.resetOrder();
        }, function (dismiss) { });
    };
    OrderSummaryComponent = __decorate([
        Component({
            selector: 'cx-ordersummary',
            templateUrl: './ordersummary.component.html',
        }),
        __metadata("design:paramtypes", [OrderService,
            CurrentOrderService,
            OrderValidation,
            Router,
            TranslateService,
            FlagService,
            ActivatedRoute,
            MixpanelService,
            LocalStorageService])
    ], OrderSummaryComponent);
    return OrderSummaryComponent;
}());
export { OrderSummaryComponent };
var OrderSummaryGuard = (function () {
    function OrderSummaryGuard(orderValidation, currentOrderService) {
        var _this = this;
        this.orderValidation = orderValidation;
        this.currentOrderService = currentOrderService;
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
    }
    OrderSummaryGuard.prototype.canActivate = function () {
        if (this.orderType.lowercaseType == "order")
            return this.orderValidation.isShippingValid();
        else if (this.orderType.lowercaseType == "quote")
            return this.orderValidation.isAddressValid();
        return false;
    };
    OrderSummaryGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation,
            CurrentOrderService])
    ], OrderSummaryGuard);
    return OrderSummaryGuard;
}());
export { OrderSummaryGuard };
//# sourceMappingURL=ordersummary.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/ordersummary.component.js
// module id = 193
// module chunks = 0